import { Component, Injector, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { DashboardComponent } from '../dashboard.component';
import Swal from "sweetalert2";

@Component({
  selector: 'app-m-dashboard',
  templateUrl: './m-dashboard.component.html',
  styleUrls: ['./m-dashboard.component.css']
})
export class MDashboardComponent extends DashboardComponent implements OnInit, OnChanges {
  @ViewChild('staticTabs', { static: true }) staticTabs?: TabsetComponent;
  @ViewChild('staticSubTabs', { static: true }) staticSubTabs?: TabsetComponent;
  @ViewChild('staticSubTabsSp', { static: false }) staticSubTabsSp?: TabsetComponent;
  @ViewChild('casinoTabs', { static: true }) casinoTabs?: TabsetComponent;
  @Input() tabSet: any;

  public menuItems: any[] = [];
  public mainTabId: any = 0;
  public cId: any; //casino id
  public eId: any; //sport event id
  public tabz: any = { home: 0, sports: 1, slot: 2, others: 3 }

  constructor(
    public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    public _message: MessageService,
    public actRoute: ActivatedRoute,
    public router: Router,
    protected injector: Injector
  ) {
    super(service, _shared, _common, actRoute, router, injector);
    this.constructorCallData();

    this._shared.sharedMenu.subscribe((res: any) => {
      if (res?.key == 'emitMenu') {
        this.menu = this.getLocalItem('menu');
        this.setData();
      }
    })
  }

  ngOnInit(): void {
    this.cId = Number(this.actRoute.snapshot.paramMap.get('cId'));
    this.eId = Number(this.actRoute.snapshot.paramMap.get('eId'));
    let r = this.router.url.split('/');
    let rd = (this.cId || this.eId) ? r.length - 2 : r.length - 1;
    this.selectTab(this.tabz[r[rd]]);
  }

  selectTab(tabId: number) {
    if (this.staticTabs?.tabs[tabId]) {
      this.mainTabId = tabId;
      this.staticTabs.tabs[tabId].active = true;
      if (this.cId) {
        this._shared.emitTabSet({ mode: 'casino' })
      }
      if (this.eId) {
        this._shared.emitTabSet({ mode: 'sports' })
      }
      this.setData();
    }
  }

  selectSubTab(tabId: number) {
    if (this.staticSubTabs?.tabs[tabId]) {
      this.staticSubTabs.tabs[tabId].active = true;
    }
  }
  selectSubTabSp(tabId: number) {
    if (this.staticSubTabsSp?.tabs[tabId]) {
      this.staticSubTabsSp.tabs[tabId].active = true;
    }
  }

  selectCasinoSubTab(tabId: number) {
    if (this.casinoTabs?.tabs[tabId]) {
      this.casinoTabs.tabs[tabId].active = true;
    }
  }

  setData() {
    if (this.mainTabId == 0) {
      this.getCasinoData();
    }
    this.setMenu('s');
    this.onMainSelect(this.mainTabId);
  }

  setMenu(key: any) {
    this.menuItems = [];
    if (this.menu != null && this.menu.length > 0)
      this.menu.forEach((element: any, i: number) => {
        if (key == 'c') {
          if (this.events.casino.includes(element.id)) {
            this.menuItems = [...this.menuItems, ...[element]]
          }
        } else {
          if (!this.events.casino.includes(element.id) && !this.events.sportsBook.includes(element.id)) {
            this.menuItems = [...this.menuItems, ...[element]]
          }
        }

        this.tabId = this.menuItems[0] ? this.menuItems[0]?.id : '';
      });

  }

  onMainSelectRoute(key: any): void {
    if (this.cId && key == 'slot') {
      this.router.navigate([`/m/${key}`, this.cId]);
    } else if (this.eId && key == 'sports') {
      this.router.navigate([`/m/${key}`, this.eId]);
    } else {
      if (key == 'sports-book') {
        if (this.isLogin()) {
          let multiplier = localStorage.getItem(`${this.env.panel}sb_multiplier`);
          let msg = `Profit & Loss in Sportsbook would be ${multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${multiplier}. <br> Please note(1 Point = ${multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${multiplier} अंक)`;
          Swal.fire({
            title: 'DO YOU AGREE?',
            html: msg,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, I Agree',
            cancelButtonText: 'No, I dont Agree'
          }).then((result) => {
            if (result.value) {
              this.router.navigate([`/m/${key}`]);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              console.log('here');
              this.router.navigate([`/m/sports`]);
            }
          });
        } else {
          this._common.openLogin();
        }
      } else {
        this.router.navigate([`/m/${key}`])
      }
    }
  }

  onMainSelect(key: any): void {

    this.data = undefined;
    if (key == 0 || key == 1) {
      this.setMenu('s');
      this.getData();

    } else if (key == 2) {
      this.setMenu('c');
    }

  }

  ngOnChanges() {
    if (this.tabSet) {
      if (this.tabSet?.mode == 'home') {
        let index = 0;
        this.menuItems.forEach((element, i) => {
          if (element.id == 4) {
            index = i;
          }
        });

        this.selectSubTab(index);
      }
      if (this.tabSet?.mode == 'casino') {
        let num = this.events.casino1.includes(this.cId) ? 0 : 1;
        this.selectCasinoSubTab(num);
      }

    }

  }

  redirectToBinaryList() {
    this.router.navigate(['/m/sports/99990'])
  }

  redirectToListAfterCheck(menuId: any) {
    let index = 0;
    //console.log(this.menuItems);
    this.menuItems.forEach((element, i) => {
      if (element?.id == menuId) { index = i; }
    });
    if (index > 0) {
      this.router.navigate(['/m/sports/' + menuId])
    } else {
      this._common.commingSoon();
    }
  }

  public checkKey: boolean = true;
  ngAfterContentChecked() {
    if (this.cId) {
      let num = this.events.casino1.includes(this.cId) ? 0 : 1;
      // this.selectCasinoSubTab(num)
    }


    if (this.eId && this.checkKey == true && this.staticSubTabsSp) {
      let index = 0;
      this.menuItems.forEach((element, i) => {
        if (element?.id == '99990') { index = i; }
        if (element?.id == '2378961') { index = i; }
      });

      this.selectSubTabSp(index);
      this.gotoDiv(`goto-sports-${index}-link`);
      this.checkKey = false;
    }
  }

}
